import { useEffect, useState } from "react";

const MAX_TITLE = 200;
const MAX_TAGS = 10;

const slugify = (text = "") =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

const ArticleInfoSection = ({
  form,
  setForm,
  errors = {},
  categories = [],
  domains = [],
  allTags = [],
}) => {
  const [tagInput, setTagInput] = useState("");
  const [showCatInput, setShowCatInput] = useState(false);
  const [newCategory, setNewCategory] = useState("");

  /* ---------------- AUTO SLUG ---------------- */
  useEffect(() => {
    if (form?.title && !form.slugTouched) {
      setForm((prev) => ({
        ...prev,
        slug: slugify(prev.title),
      }));
    }
  }, [form?.title, form?.slugTouched, setForm]);

  /* ---------------- TAGS ---------------- */

  const addTag = (tag) => {
    if (
      !tag ||
      form.tags.includes(tag) ||
      form.tags.length >= MAX_TAGS
    )
      return;

    setForm((prev) => ({
      ...prev,
      tags: [...prev.tags, tag],
    }));
    setTagInput("");
  };

  const removeTag = (tag) => {
    setForm((prev) => ({
      ...prev,
      tags: prev.tags.filter((t) => t !== tag),
    }));
  };

  /* ---------------- RENDER ---------------- */

  return (
    <section className="article-info-section">
      <h4>Article Info</h4>

      <div className="article-info-grid">
        {/* TITLE */}
        <div className="field">
          <input
            placeholder="Article title"
            value={form.title}
            maxLength={MAX_TITLE}
            onChange={(e) =>
              setForm({ ...form, title: e.target.value })
            }
          />
          <div className="field-meta">
            <small>
              {form.title.length}/{MAX_TITLE}
            </small>
            {errors.title && (
              <small className="error">{errors.title}</small>
            )}
          </div>
        </div>

        {/* SLUG */}
        <div className="field">
          <input
            placeholder="URL Slug"
            value={form.slug}
            onChange={(e) =>
              setForm({
                ...form,
                slug: e.target.value,
                slugTouched: true,
              })
            }
          />
          <small className="slug-preview">
            Preview: yoursite.com/help/
            {form.slug || "your-slug"}
          </small>
          {errors.slug && (
            <small className="error">{errors.slug}</small>
          )}
        </div>

        {/* CATEGORY */}
        <div className="field">
          <select
            value={form.category}
            onChange={(e) =>
              e.target.value === "__new__"
                ? setShowCatInput(true)
                : setForm({ ...form, category: e.target.value })
            }
          >
            <option value="">Select category</option>
            {categories.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </select>
          {errors.category && (
            <small className="error">{errors.category}</small>
          )}
        </div>

        {/* DOMAIN (optional — maps the article to a chat vertical/domain) */}
        <div className="field">
          <select
            value={form.domain ?? ""}
            onChange={(e) =>
              setForm({ ...form, domain: e.target.value })
            }
          >
            <option value="">Select domain (optional)</option>
            {domains.map((d) => (
              <option key={d.id} value={d.id}>
                {d.name}
              </option>
            ))}
          </select>
          <small className="slug-preview">
            Which chat vertical this article belongs to
          </small>
        </div>

        {/* TAGS */}
        <div className="field tag-field">
          <div className="tag-input-wrapper">
            {form.tags.map((t) => (
              <span key={t} className="tag-chip">
                {t}
                <button type="button" onClick={() => removeTag(t)}>
                  ×
                </button>
              </span>
            ))}

            <input
              placeholder="Add tag"
              value={tagInput}
              onChange={(e) => setTagInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === ",") {
                  e.preventDefault();
                  addTag(tagInput.trim());
                }
              }}
            />
          </div>

          {tagInput && (
            <div className="tag-suggestions">
              {allTags
                .filter(
                  (t) =>
                    t.toLowerCase().includes(tagInput.toLowerCase()) &&
                    !form.tags.includes(t)
                )
                .slice(0, 5)
                .map((t) => (
                  <div key={t} onClick={() => addTag(t)}>
                    {t}
                  </div>
                ))}
            </div>
          )}

          <small>
            {form.tags.length}/{MAX_TAGS} tags
          </small>
        </div>
      </div>
    </section>
  );
};

export default ArticleInfoSection;
